module.exports = __webpack_public_path__ + "static/media/bd.b2af3176.svg";